var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"row no-gutters border rounded overflow-hidden flex-md-row mb-4 p-0 shadow-sm h-md-250 position-relative"})])
}]

export { render, staticRenderFns }